import { Badge } from '@/components/ui/badge';
import { ReactNode } from 'react';

interface GroupDividerLayoutProps {
  rowCount: number;
  children: ReactNode;
}

export function GroupDividerLayout({ rowCount, children }: GroupDividerLayoutProps) {
  return (
    <span className="flex items-center gap-2 text-sm pl-3">
      {children}
      <Badge variant="secondary" className="bg-air-blue-subdued hover:bg-air-blue-subdued text-air-dark-blue">
        {rowCount}
      </Badge>
    </span>
  );
}
